import { Button } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { fetchEnd, fetchStart, useNotify } from "react-admin";
import { useDispatch } from "react-redux";
import { httpClient } from "../../../App";
import { API_CONFIG } from "../../../common/config/api.config";

/* const useStyles = makeStyles((theme) => {
  return {
    successLabel: {
      color: theme.palette.success.main, // 🔴
    },

    dangerLabel: {
      color: theme.palette.warning.main, // 🔴
    },
  };
}); */

const CreateNewReleaseCycleButton = (props: any) => {
  const dispatch = useDispatch();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { record } = props;

  const sendRequest = useCallback(() => {
    setLoading(true);
    dispatch(fetchStart()); // start the global loading indicator

    httpClient(
      `${API_CONFIG.FAMILY_SERVICE.ADMIN_ENDPOINTS.ADMIN_BASE_URL}/${record.uuid}/releaseCycle`,
      {
        method: "POST",
      }
    )
      .then((result) => {
        if (result.status === 201) {
          notify("New Release Cycle created.");
        }
      })
      .catch((e) => {
        notify("Could not generate Newspaper", "warning");
      })
      .finally(() => {
        setLoading(false);
        dispatch(fetchEnd()); // stop the global loading indicator
      });
  }, [dispatch, notify, record]);

  return (
    <Button
      color="secondary"
      variant="outlined"
      onClick={sendRequest}
      disabled={loading}
    >
      Create New Release Cycle
    </Button>
  );
};

export default CreateNewReleaseCycleButton;
